import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import {
    Row,
    Col,

} from "react-bootstrap";
import "./depos.css";
import BootstrapTable from 'react-bootstrap-table-next';

import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';

import { toast } from "react-toastify";
import { AXIOS, api_key } from "../../config";
import ReactTable from "../withdraw/reactTable";
import {

    MdContentCopy,

} from "react-icons/all";
import CopyAndShortFormer from "../copyAndShortFormer";



const DepositHistory = () => {


    const MAX_LENGTH = 15; // adjust this based on your needs

    const addressFormatter = (cell, row) => {

        // console.log('cellllll value', cell)
        // if (cell.length > MAX_LENGTH) {
        //     const truncatedAddress = cell.slice(0, MAX_LENGTH) + '...';
        //     return (
        //         <div>
        //             {truncatedAddress}
        //             {/* <CopyToClipboard text={cell}>
        //       <button className="btn btn-link">📋</button> 
        //     </CopyToClipboard> */}
        //         </div>
        //     );
        // }
        // return cell;
    };


    const columns = [
        { text: "Time", dataField: "date" },
        // { Header: "Time", accessor: "date" },
        // { Header: "Currency", accessor: "currency" },
        { text: "Currency", dataField: "currency" },
        { text: "Amount", dataField: "amount" },
        { text: "Network", dataField: "network" },
        {
            text: "Address", dataField: "fromAddress",
            formatter: (cellContent, row) => <CopyAndShortFormer value={cellContent} />
        },
        {
            text: "TXID", dataField: "hash",
            formatter: (cellContent, row) => <CopyAndShortFormer value={cellContent} />
        },
        {
            text: "Status", dataField: "status",
            formatter: (cellContent, row) => {
                return cellContent == 1
                    ? 'completed'
                    : 'pending';
            }
        },

        // { Header: "Amount", accessor: "amount" },
        // { Header: "Network", accessor: "status" },
        // {
        //     Header: "Address", accessor: "fromAddress",
        //     Cell: (row: any) => {
        //         console.log('address', row)
        //         return <CopyAndShortFormer value={row.value} />
        //     }
        // },
        // {
        //     Header: "TXID", accessor: "hash",
        //     Cell: (row: any) => {
        //         console.log('hash', row)
        //         return <CopyAndShortFormer value={row.value} />
        //     }
        // },
        // {
        //     Header: "Status", accessor: "status",
        //     Cell: (row: any) => {

        //         return row.value == 1
        //             ? 'completed'
        //             : 'pending';
        //     }
        // },
    ];

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([
        // {
        //     date: "2023-08-09 10:00:00",
        //     currency: "BTC",
        //     amount: "0.5",
        //     network: "Bitcoin",
        //     fromAddress: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
        //     hash: "sampleHash12345678",
        //     status: 1
        //   },
        //   {
        //     date: "2023-08-09 11:00:00",
        //     currency: "ETH",
        //     amount: "10",
        //     network: "Ethereum",
        //     fromAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
        //     hash: "sampleHashabcdef1234",
        //     status: 0
        //   },
        //   {
        //     date: "2023-08-09 12:00:00",
        //     currency: "LTC",
        //     amount: "15",
        //     network: "Litecoin",
        //     fromAddress: "LdP8Qox1VAhCzLJNqrr74YovaWYyNBUWvL",
        //     hash: "sampleHashzyxwvu5678",
        //     status: 1
        //   }
    ]);
    let userid = sessionStorage.getItem("userid");
    const getDepositHistory = async () => {
        try {
            let arr = []
            let depositHistory = await AXIOS
                .post('getAllDepositHistory', {
                    api_key: api_key,
                    user_id: userid
                })
            console.log('depositHistory', depositHistory.data.data)

            if (depositHistory.data.status == 'success') {

                setData(depositHistory.data.data)
                setLoading(false)
            }

        } catch (error) {
            setLoading(false)
        }
    }
    useEffect(() => { getDepositHistory() }, []);
    const options = {
        custom: true,
        totalSize: data.length
    };

    return (
        <>
            <Row className="mt-5 rt_snd_r">
                <Col>
                    <div className="d-flex justify-content-between">
                        <div className="head d-flex gap-5 align-items-center">
                            <h2>Recent deposit records</h2>
                        </div>
                    </div>
                    {
                        loading ? <>
                            <div className=" text-center mt-5">
                                <span>Loading...</span>
                            </div>
                        </> : <>
                            <div className="rc_dp_tb">
                                {data.length > 0 &&
                                    <PaginationProvider
                                        pagination={paginationFactory(options)}
                                    >
                                        {
                                            ({
                                                paginationProps,
                                                paginationTableProps
                                            }) => (
                                                <div>
                                                    <BootstrapTable
                                                        keyField="id"
                                                        bordered={false}

                                                        data={data}
                                                        columns={columns}
                                                        {...paginationTableProps}
                                                    />

                                                    {
                                                        data.length > 10 &&
                                                        <PaginationListStandalone
                                                            {...paginationProps}
                                                        />
                                                    }


                                                </div>
                                            )
                                        }
                                    </PaginationProvider>}
                                {/* <ReactTable columns={columns} data={data} rowsPerPage={2} /> */}
                            </div>
                        </>
                    }
                </Col>
            </Row>
        </>
    );
};

export default DepositHistory;



